<template>
  <div>
    <div class="img">
      <div class="img-top">
        <img src="../src/assets/logo-3.png" alt="" style="display: block; height: 70px;margin-left: 54px;">
        <img src="../src/assets/logo-2.png" alt="" style="display: block; width: 262px;height: 58px;margin-left: 30px;">
      </div>

      <div class="footer" style="margin-left: 54px;">
        <div style="width: 210px;height: 85px;text-align: center;line-height: 85px;border-radius: 12px 12px 12px 12px;" @click="zhuisu">中药材追溯系统</div>
        <div style="width: 210px;height: 85px;text-align: center;line-height: 85px;margin-left: 46px;border-radius: 12px 12px 12px 12px;" @click="yonghu">用户信息管理系统</div>
      </div>
      <div class="footertwo" style="margin-left: 54px;">
        <div style="width: 210px;height: 85px;text-align: center;line-height: 85px;border-radius: 12px 12px 12px 12px;" @click="cangchu">中药材仓储系统</div>
        <div style="width: 210px;height: 85px;text-align: center;line-height: 85px;margin-left: 46px;border-radius: 12px 12px 12px 12px;" @click="cangdan">中药材仓单系统</div>
      </div>
      
      <div class="footer-text" style="position: absolute;bottom: 27px;">
        <div style="margin-left: 48px;">北京合众盈泰中药材产业科技发展中心(有限合伙)</div>
        <div style="margin-left: 54px;">七代志小镇（北京）科技有限公司</div>
      </div>
    </div>
  </div>  
</template>
<script>
export default {
  data(){
    return {
    }
  },
  methods:{
    zhuisu(){
      window.open('http://8.131.238.81:5050/#/login')
    },
    yonghu(){
      window.open('http://8.131.238.81:8081/user/#/login')
    },
    cangchu(){
      window.open('http://8.131.238.81:8089/#/login')
    },
    cangdan(){
      window.open('http://8.131.238.81:8090/#/login')
    }
  }
}
</script>
<style lang="scss">
.img{
  background-image: url('../src/assets/back.png');
  background-size: cover;
  height: 100vh;
  width: 100%;
  background-position: center;
}
.img-top{
  display: flex;
  align-items: center;
  padding-top: 5%;
}
.footertwo{
  display: flex;
  align-items: center;
  div{
    font-weight: bold;
    color: #00B7BE;
    background: linear-gradient( 180deg, #A9FDFD 0%, #0EE9D7 100%);
  }
  margin-top: 3%;
}
.footer-text{
  display: flex;
  div{
    color: #989898;
    font-weight: bold;
    font-family: 思源宋体N;
  }
}
.footer{
  display: flex;
  align-items: center;
  margin-top: 10%;
  div{
    font-weight: bold;
    color: #00B7BE;
    background: linear-gradient( 180deg, #A9FDFD 0%, #0EE9D7 100%);
  }
}
</style>
